import {
  TransitionScreen,
  transitionActionLinkClassNames,
} from '../TransitionScreen';
import { emailLink } from '../utils';

export const InviteError = ({ error }: { error: Error }) => {
  const inviteNotFound = error.message.includes('was not found');

  return (
    <TransitionScreen
      title={
        inviteNotFound
          ? "Sorry, we couldn't find that invite"
          : 'Something went wrong'
      }
      description={
        inviteNotFound
          ? "Try the link from your invitation email again. If that doesn't work, contact us for help."
          : 'Something went wrong on our end. Try refreshing the page or contact us for help.'
      }
      actions={
        <a
          href={emailLink('Account invite issue', error.message)}
          className={transitionActionLinkClassNames.primary}
         data-track-source-anchor="c69acfe4ff">
          Contact support
        </a>
      }
    />
  );
};
